/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_ORG_LIST = gql`
  query Query($input: GetOrgListInput) {
    getListOfOrg(input: $input) {
      totalCount
      totalPages
      pageSize
      currentPage
      data {
        orgId
        name
        description
        email
        registrationNo
        trn
        incorporationDate
        type
        dateOfRegistration
        fax

        natureOfBusiness
        website
        primaryContactNo
        status
        logo
        socialLinks
        country
      }
    }
  }
`;
